<template>
    <div>
        <div class="media">
            <div class="media-content">
                <p class="title is-3 is-uppercase">{{ nameJobsite }}</p>
                <p class="subtitle adress-format">{{ adress }}</p>

                <br />
                <b>Date of last read email:</b>
                <div v-if="workunits.length && Array.isArray(workunits[0].workunitadvance) && workunits[0].workunitadvance.length">
                    <span class="is-size-6 has-text-link has-text-weight-semibold">{{ moment(workunits[0].workunitadvance[0].updatedAt).format('DD/MM/YYYY') }}</span>
                </div>
                <div v-else>
                    <span class="is-size-6 has-text-link has-text-weight-semibold">{{ moment(updatedAt).format('DD/MM/YYYY') }}</span>
                </div>
                <p class="has-text-right has-text-weight-medium is-size-5"
                   style="margin-bottom: 20px;">{{ location }}</p>
            </div>
        </div>

        <div class="content">
            <div>
                <div>
                    <p class="subtitle is-5 has-text-weight-medium has-text-link">
                        <span class="icon has-text-link">
                            <i class="mdi mdi-chart-bar"></i>
                        </span>Daily Produced Length
                    </p>
                    <p class="has-text-right">
                        <span class="tag is-warning is-medium"
                              style="margin-right: 10px;">{{ sumDay(workunits) }} m</span>
                    </p>
                </div>
                <div>
                    <p class="subtitle is-5 has-text-weight-medium has-text-link">
                        <span class="icon has-text-link">
                            <i class="mdi mdi-trending-up"></i>
                        </span>Cumulated Produced Length
                    </p>
                    <p class="has-text-right">
                        <span class="tag is-warning is-medium"
                              style="margin-right: 10px;">{{ sumTotal(workunits) }} m / {{ workunits[0].discLenght }} m</span>

                        <span class="tag is-info is-medium" style="margin-right: 10px;">{{ percentTotal(workunits)}}</span>
                        <span class="tag is-medium"
                              >Internal diameter : {{ workunits[0].diameter }} m</span>
                    </p>
                </div>
                 <div>
                    <p class="subtitle is-5 has-text-weight-medium has-text-link">
                        <span class="icon has-text-link">
                            <i class="mdi mdi-trending-up"></i>
                        </span>Project Cumulated Produced Length
                    </p>
                    <p class="has-text-right">
                        <span class="tag is-warning is-medium"
                              style="margin-right: 10px;">{{ allProjectLength(workunits) }}</span>
                        <span class="tag is-info is-medium">{{ allProjetLengthPercent }} %</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'


    export default {
        name: 'InfoMap',
        data () {
            return {
                active: false,
                allProjetLengthPercent: 0
            }

        },
        props: {
            nameJobsite: {
                type: String,
                default: '',
            },
            numberJobsite: {
                type: Number,
            },
            location: {
                type: String,
                default: '',
            },
            workunits: {
                type: Array,
            },
            updatedAt: {
                default: null,
            },
            adress: {
                type: String,
                default: '',
            }
        },
        methods: {
            sumDay(dataRow) {
                let sum = 0;
                if (dataRow != null && dataRow.length > 0) {
                        const dataTmp = dataRow[0];
                        if (dataTmp.workunitadvance.length > 0) {
                            const workUnitAdvance = dataTmp.workunitadvance[0];
                            sum = parseFloat(workUnitAdvance.lenghtWork);
                        }
                }
                return sum.toFixed(2);
            },
            sumTotal(dataRow) {
                let sum = 0;
                const getTotalWork = this.getTotalWork(dataRow);
                 if(dataRow.length>0)
                    {
                        const dataLast = dataRow[0];
                        if (dataLast.workunitadvance.length > 0) {
                            if(dataLast.workunitadvance[0].lenghtAccumulated <= getTotalWork){
                                sum = dataLast.workunitadvance[0].lenghtAccumulated;
                            }
                        }
                    }
                return sum.toFixed(2);
            },
            allProjectLength(dataRow){
                let sum = 0;
                let driveLengthTotal = 0;
                if(dataRow.length>0){

                    for(let i=0; i<dataRow.length;i++){
                        const drive=dataRow[i]
                        driveLengthTotal += parseInt(drive.discLenght);
                        if(!drive.force_end_drive){
                            if(drive.workunitadvance.length>0){
                                if(drive.workunitadvance[0].lenghtAccumulated > 0){
                                    sum = drive.workunitadvance[0].lenghtAccumulated;
                                }
                            }
                        } else {
                            sum = parseInt(drive.discLenght)
                        }

                    }
                }
                this.allProjetLengthPercent = +((sum * 100) / driveLengthTotal).toFixed(2);
                return `${sum.toFixed(2)} m / ${driveLengthTotal} m`;
            },

            getTotalWork(dataRow) {
                let sumTotal = 0;
                if (dataRow != null) {
                    if (dataRow.length > 0) {

                        for (let i = 0; i < dataRow.length; i++) {
                            sumTotal += parseFloat(dataRow[i].discLenght);
                        }
                    }
                }
                return sumTotal;
            },
            percentTotal(dataRow) {
                const lenghtAccumulated = this.sumTotal(dataRow);

                return ((lenghtAccumulated * 100) / dataRow[0].discLenght).toFixed(2) + '%';
            },
            moment: function (date) {
                return moment(date)
            },
        },
    }
</script>
<style scoped>
    .show-com{
        display: none;
    }
    .comments{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .comments b{
        font-size: 1.5em;
    }
    .toggle-comments{
        background: white;
        border: none;
    }
    .toggle-comments i{
        font-size: 3rem;
        color: darkgrey;
        cursor: pointer;
    }
</style>
